module.exports = __webpack_public_path__ + "static/187448590-d60d412c5b1d9b228030c82cf6f65d79.jpg";